import styled from "@emotion/styled";
import {
  EmailInput as SignUpNewsletterEmailInput,
  StyledSignupButton as SignUpNewsletterSignUpButton,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SubmitButton as SignUpButtonSubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import {
  Container as SocialButtonContainer,
  IconContainer as SocialButtonIconContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontRoboto, theme } from "shared/lib/styles";

import { TitleDisplay } from "./title-display";

export const AgreementCheckboxContainer = styled.div`
  cursor: pointer;
`;

export const AgreementDescription = styled.div`
  max-inline-size: 340px;
  margin-inline-start: 8px;

  color: #000000;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 13px;
  text-align: start;
`;

type AgreementContainerProps = {
  theme?: ThemeType;
};
export const AgreementContainer = styled.div<AgreementContainerProps>`
  display: flex;

  margin-block-start: 24px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const ActionContainer = styled.div`
  margin-block-end: 8px;
`;

export const TermAndConditionLink = styled.a`
  margin-block: 0;
  margin-inline: 2px;
`;
export const TermAndConditionContainer = styled.div`
  color: #999999;
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 11px;
  white-space: nowrap;

  ${TermAndConditionLink} {
    color: #999999;
    text-decoration: underline;
  }
`;

type ContainerProps = {
  theme?: ThemeType;
};
export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-flow: column;
  gap: 2px;
  justify-items: center;

  max-inline-size: 500px;
  margin: auto;
  padding: 0;

  color: #ffffff;
  text-align: center;

  ${SignUpButtonSubmitButton} {
    display: flex;
    justify-content: center;
    align-items: center;

    block-size: 36px;
    min-inline-size: 173px;
    padding-inline: 16px;
    ${theme.breakpoints.up("tablet")} {
      min-inline-size: 205px;
    }
  }

  ${SignUpNewsletterSignUpButton} {
    min-inline-size: 86px;

    font-family: ${fontRoboto};
  }

  ${SocialButtonContainer} {
    justify-content: center;

    ${SocialButtonIconContainer} {
      background-color: #ffffff;
    }
  }

  ${SignUpNewsletterEmailInput} {
    ${theme.breakpoints.up("tablet")} {
      inline-size: 186px;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    justify-items: center;

    max-inline-size: initial;
    margin: initial;

    text-align: center;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  ${theme.breakpoints.up("tablet")} {
    flex-flow: row;
  }
`;

export const Bottom = styled.div`
  ${theme.breakpoints.up("tablet")} {
    align-self: flex-end;
  }
`;

export const TitleAndDescriptionContainer = styled.div`
  inline-size: 100%;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    text-align: start;
  }
`;

export const SummaryContainer = styled.div`
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const ActionAndTermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    justify-self: end;
    align-items: end;

    inline-size: unset;
  }
`;

export const EmptyDiv = styled.div`
  display: none;
`;

export const FadeContainer = styled.div`
  display: flex;
  justify-content: center;
  ${theme.breakpoints.up("tablet")} {
    gap: 16px;
    justify-content: unset;
  }
`;

export const ContentContainer = styled.div`
  display: none;
  ${theme.breakpoints.up("tablet")} {
    display: block;

    inline-size: 100%;
  }
`;
export const MobileContentContainer = styled.div`
  display: block;
  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledTitleDisplay = styled(TitleDisplay)`
  margin-block-start: 12px;
`;
